import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Clock } from "lucide-react";
import "../../assets/styles/Login.css"; // Reuse Variables
import "../../assets/styles/Legal.css"; // New Styles
import { privacyPolicyData, termsData } from "./legalData.js"; // Import Data

const LegalPage = ({ type }) => {
  const isPrivacy = type === "privacy";
  const data = isPrivacy ? privacyPolicyData : termsData;
  const pageTitle = isPrivacy ? "Privacy Policy" : "Terms & Conditions";
  const lastUpdated = "February 10, 2026";

  const [activeSection, setActiveSection] = useState(data[0].id);

  // --- Scroll Spy Logic (Advanced) ---
  // بيشوف اليوزر بيعمل سكرول فين ويغير الـ Active Link لوحده
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150; // Offset

      data.forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + height
          ) {
            setActiveSection(section.id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [data]);

  // Smooth Scroll function
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 140, // Adjust for Navbar
        behavior: "smooth",
      });
      setActiveSection(id);
    }
  };

  return (
    <>
      {/* Background Orbs */}
      <div className="background-wrapper">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
      </div>

      <div className="legal-wrapper">
        <Container>
          <Row>
            {/* --- Left Sidebar (Table of Contents) --- */}
            <Col lg={3} className="d-none d-lg-block">
              <div className="legal-sidebar">
                <div className="legal-nav-title">ON THIS PAGE</div>
                <nav>
                  {data.map((item) => (
                    <div
                      key={item.id}
                      className={`legal-nav-link ${
                        activeSection === item.id ? "active" : ""
                      }`}
                      onClick={() => scrollToSection(item.id)}
                    >
                      {item.title}
                    </div>
                  ))}
                </nav>
              </div>
            </Col>

            {/* --- Right Content --- */}
            <Col lg={9} md={12}>
              <div className="legal-content-card">
                
                {/* Header */}
                <div className="legal-header">
                  <h1 className="legal-title">{pageTitle}</h1>
                  <div className="legal-last-updated">
                    <Clock size={16} />
                    <span>Last Updated: {lastUpdated}</span>
                  </div>
                </div>

                {/* Dynamic Content */}
                {data.map((section, index) => (
                  <div key={section.id} id={section.id} className="legal-section">
                    <h3>
                        <span style={{color: '#6366f1'}}>{section.icon}</span> 
                        {index + 1}. {section.title}
                    </h3>
                    <div>{section.content}</div>
                  </div>
                ))}

                {/* Footer Note */}
                <div className="mt-5 pt-4 border-top border-secondary">
                    <p className="text-secondary small fst-italic">
                        Disclaimer: This document is for the CampusPulse student community project. 
                        It is not a legally binding contract in a real-world court of law but serves as the guidelines for our community.
                    </p>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LegalPage;